import React, {Fragment} from 'react';
import {Icon, IconButton, Typography} from '@bonprix/design-system';
import LandmarkAdapter from '../../../../../../../../core/src/main/resources/scripts/components/landmark-adapter.js';

export default function Coupon({texts, coupon, clickHandler, page, setCouponEdited}) {
    const edit = () => {
        LandmarkAdapter.sendClickLandmark(page + "_code_edit");
        clickHandler();
        setCouponEdited(true);
    }

    return (
        <>
            <div className="flex">
                <div className="mr-1.5">
                    <Icon className="cart__coupon__check fill-clr-fg-success" variant="check-bold" />
                </div>
                <div className="mr-2.5 pt-0.5">
                    <div className="cart__coupon__messages" test-ref__cart-coupon-messages="">
                        <Typography bold>{texts.cot19_voucher_active}</Typography>
                    </div>
                    <div className="mt-1.5">
                        <Typography variant='body2' color='on-bg-mid'>({coupon.code})</Typography>
                    </div>
                </div>
                <div className="flex">
                    <div className="cursor-pointer">
                        <IconButton
                            icon="edit"
                            label={texts.checkout__edit_icon_screenreader_label}
                            variant="tertiary"
                            onClick={edit}
                            small
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
